<!--Wrapper Start-->
<div style="background: #101e2a;">
  <div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <div class="pr-4 pt-4" id="sidebar-wrapper" *ngIf="showSideMenu">
      <button id="close_sidebar">
        <img src="assets/images/close.png" width="16" alt="Close Button Image" />
      </button>
      <span class="sidebar-logo">
        <img class="pointer" src="/assets/images/bars.png" (click)="showSideMenuFn()" alt="Line Bars Image" width="27"/>
        <img src="assets/images/logo.png" alt="Site Logo" width="200" style="margin-left:7px;"/>
      </span>
      <div class="list-group list-group-flush mt-5">
        <a routerLink="/image-editor">
          CREATE TEMPLATE</a>
          <a routerLinkActive="active" id="toggle_menu" routerLink="/panel">
            READY-MADE TEMPLATES
            <img src="assets/images/angle_down.png" class="angle_down" width="10" alt="Angle Down Image"/>
          </a>
          <a routerLinkActive="active" id="toggle_menu" routerLink="/users">USERS LIST</a>
          <a class="pointer" (click)="addUser()">
            <i class="fa fa-plus" aria-hidden="true"></i>&nbsp; Create User
          </a>
        </div>
      </div>
      <!-- /#sidebar-wrapper -->

      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav class="navbar navbar-expand-lg navbar-light pb-4">
          <button class="btn btn-primary" id="menu-toggle" (click)="showSideMenuFn()" *ngIf = "!showSideMenu">
            <img src="assets/images/bars.png" alt="Line Bars Image" />
          </button>
          <div class="" style="padding-left: 80%;">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle pr-0" id="navbarDropdown" role="button" (click)="showMenuFn()" >
                  <img src="assets/images/user.png" width="50" class="img-fluid" alt="User Image" />
                </a>
                <div class="dropdown-menu dropdown-menu-right" style="display: block;" *ngIf="showMenu" >
                  <a class="dropdown-item" href="#" >
                    <img src="assets/images/settings.png" alt="Settings Image" width="20" />
                    Setting
                  </a>
                  <a class="dropdown-item" (click)="Logout()" >
                    <img src="assets/images/logout.png" alt="Logout Image" width="20"/>
                    Log Out
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="row">
          <div class="col-sm-12">
            <div class="container">
              <ul class="responsive-table">
                <li class="table-header">
                  <div class="col col-2">Name</div>
                  <div class="col col-6">Email</div>
                  <div class="col col-2">Role</div>
                  <div class="col col-2">Action</div>
                </li>
                <li class="table-row" *ngFor="let user of users">
                  <div class="col col-2" data-label="Job Id">{{ user.name }}</div>
                  <div class="col col-6" data-label="Customer Name">{{ user.email }}</div>
                  <div class="col col-2" data-label="Amount">{{ user.role.role }}</div>
                  <div class="col col-2" data-label="Payment Status">
                    <div class="dropdown">
                      <button class="btn btn-sm" (click)="editUser(user)">
                        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                      </button>
                      <button class="btn btn-sm" (click)="deleteUser(user)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </li>
                <br>
                <ngb-pagination *ngIf="pagination.size > pagination.pageSize" (pageChange)="OnPageChange($event)" [collectionSize]="pagination.size" [(page)]="pagination.currentPage" [pageSize]="pagination.pageSize" [maxSize]="pagination.maxSize" [rotate]="true"></ngb-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
    </div>
  </div>
